<template>
  <section class="chart-profit-quarter">
    <companyTitle :isShowCompanyInfo="true"></companyTitle>
    <error-alert v-if="$store.getters.errorMessage" />
    <template v-else>
      <b-row class="justify-content-around">
        <ChartLine id="ROE-quarter" :config="itemsOfROEQuarter" />
        <ChartLine
          id="cash-flowCompensation-quarter"
          :config="itemsOfCashFlowCompensationQuarter"
        />
        <ChartLine
          id="operating-margin-quarter"
          :config="itemsOfOperatingMarginQuarter"
        />
        <ChartLine
          id="cash-flow-use-quarter"
          :config="itemsOfCashFlowUseQuarter"
        />
        <ChartLine
          id="cash-flow-change-quarter"
          :config="itemsOfOperatingRevenueAndExpenseChangeQuarter"
        />
        <ChartLine
          id="cash-flow-change-quarter"
          :config="itemsOfCashFlowChangeQuarter"
        />
      </b-row>
    </template>
  </section>
</template>

<script>
import ChartLine from "@/components/ChartLine.vue";
import ErrorAlert from "@/components/ErrorAlert.vue";
import companyTitle from "@/components/CompanyTitle.vue";
export default {
  name: "ChartProfitQuarter",
  components: {
    ChartLine,
    ErrorAlert,
    companyTitle
  },
  computed: {
    /***********************************************************
      淨利報酬率，欄位如下： 
      ROA ( ROA )
      ROE ( ROE )
      ROIC ( ROIC )
    ***********************************************************/
    itemsOfROEQuarter() {
      const chartFields = [
        {
          key: "ROA",
          color: this.$store.getters.chartColors.eucalyptus
        },
        {
          key: "ROE",
          color: this.$store.getters.chartColors.dodgerBlue
        },
        {
          key: "ROIC",
          color: this.$store.getters.chartColors.fuchsiaBlue
        }
      ];
      const chartOptions = {
        title: "淨利報酬率",
        step: 10,
        //此圖 y 軸單位是百分比
        axesYUnit: "percentage"
      };
      const chartData = this.$store.getters.formatToChartDataQuarter(
        this.$store.getters.chartProfitQuarter.ROE,
        chartFields,
        chartOptions
      );
      return chartData;
    },
    /***********************************************************
      現金流量報酬率，欄位如下： 
      EBOA ( EBOA )
      EBOE ( EBOE )
      EBOIC ( EBOIC )
    ***********************************************************/
    itemsOfCashFlowCompensationQuarter() {
      const chartFields = [
        {
          key: "EBOA",
          color: this.$store.getters.chartColors.pelorous
        },
        {
          key: "EBOE",
          color: this.$store.getters.chartColors.cerise
        },
        {
          key: "EBOIC",
          color: this.$store.getters.chartColors.amber
        }
      ];
      const chartOptions = {
        title: "現金流量報酬率",
        step: 10,
        //此圖 y 軸單位是百分比
        axesYUnit: "percentage"
      };
      const chartData = this.$store.getters.formatToChartDataQuarter(
        this.$store.getters.chartProfitQuarter.cashFlowCompensation,
        chartFields,
        chartOptions
      );
      return chartData;
    },
    /***********************************************************
      營業利益率，欄位如下： 
      gross_profit_ratio ( 毛利率 )
      operating_expense_ratio ( 營業費用率 )
      net_profit_margin_ratio ( 淨利率 )
    ***********************************************************/
    itemsOfOperatingMarginQuarter() {
      const chartFields = [
        {
          key: "gross_profit_ratio",
          color: this.$store.getters.chartColors.amaranth
        },
        {
          key: "operating_expense_ratio",
          color: this.$store.getters.chartColors.pelorous
        },
        {
          key: "net_profit_margin_ratio",
          color: this.$store.getters.chartColors.pumpkin
        }
      ];
      const chartOptions = {
        title: "營業利益率",
        step: 10,
        //此圖 y 軸單位是百分比
        axesYUnit: "percentage"
      };
      const chartData = this.$store.getters.formatToChartDataQuarter(
        this.$store.getters.chartProfitQuarter.operatingMargin,
        chartFields,
        chartOptions
      );
      return chartData;
    },
    /***********************************************************
      現金流量用途分析，欄位如下： 
      cash_reinvestment_ratio ( 現金再投資比例 )
      dividend_redistribution_ratio ( 現金股利分配比例 )
    ***********************************************************/
    itemsOfCashFlowUseQuarter() {
      const chartFields = [
        {
          key: "cash_reinvestment_ratio",
          color: this.$store.getters.chartColors.fuchsiaBlue
        },
        {
          key: "dividend_redistribution_ratio",
          color: this.$store.getters.chartColors.mountainMeadow
        }
      ];
      const chartOptions = {
        title: "現金流量用途分析",
        step: 10,
        //此圖 y 軸單位是百分比
        axesYUnit: "percentage"
      };
      const chartData = this.$store.getters.formatToChartDataQuarter(
        this.$store.getters.chartProfitQuarter.cashFlowUse,
        chartFields,
        chartOptions
      );
      return chartData;
    },
    /***********************************************************
      營收與損益變化分析，欄位如下： 
      net_operating_revenue ( 營業收入淨額 )
      operating_income ( 營業利益 )
      total_non_operating_revenue_and_expense ( 營業外收入及支出 )
    ***********************************************************/
    itemsOfOperatingRevenueAndExpenseChangeQuarter() {
      const chartFields = [
        {
          key: "net_operating_revenue",
          color: this.$store.getters.chartColors.amber
        },
        {
          key: "operating_income",
          color: this.$store.getters.chartColors.eucalyptus
        },
        {
          key: "total_non_operating_revenue_and_expense",
          color: this.$store.getters.chartColors.dodgerBlue
        }
      ];
      const chartOptions = {
        title: "營收與損益變化分析",
        step: null,
        //此圖 y 軸單位是元
        axesYUnit: "price"
      };
      const chartData = this.$store.getters.formatToChartDataQuarter(
        this.$store.getters.chartProfitQuarter
          .operating_revenue_and_expense_change,
        chartFields,
        chartOptions
      );
      return chartData;
    },
    /***********************************************************
      現金流量變化分析，欄位如下： 
      cash_dividends_paids_CFF ( 支付現金股利-CFF )
      cash_flows_from_operations ( 來自營運之現金流量 )
      cash_flow_from_investment_activities ( 投資活動之現金流量 )
      cash_flow_from_fundraising ( 籌資活動之現金流量 )
      cash_flow_during_this_period ( 本期產生現金流量 )
    ***********************************************************/
    itemsOfCashFlowChangeQuarter() {
      const chartFields = [
        {
          key: "cash_dividends_paids_CFF",
          color: this.$store.getters.chartColors.fuchsiaBlue
        },
        {
          key: "cash_flows_from_operations",
          color: this.$store.getters.chartColors.cerise
        },
        {
          key: "cash_flow_from_investment_activities",
          color: this.$store.getters.chartColors.dodgerBlue
        },
        {
          key: "cash_flow_from_fundraising",
          color: this.$store.getters.chartColors.mountainMeadow
        },
        {
          key: "cash_flow_during_this_period",
          color: this.$store.getters.chartColors.pumpkin
        }
      ];
      const chartOptions = {
        title: "現金流量變化分析",
        step: null,
        //此圖 y 軸單位是元
        axesYUnit: "price"
      };
      const chartData = this.$store.getters.formatToChartDataQuarter(
        this.$store.getters.chartProfitQuarter.cash_flow_change,
        chartFields,
        chartOptions
      );
      return chartData;
    }
  }
};
</script>

<style lang="scss" scoped></style>
